(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var sections = Array.prototype.slice.call(document.querySelectorAll('[data-pfs-scroll]'));
  if (!sections.length || reduceMotion) return;

  var raf = 0;

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function smooth(value) {
    return value * value * (3 - (2 * value));
  }

  function updateSection(section) {
    var rect = section.getBoundingClientRect();
    var distance = Math.max(1, rect.height - window.innerHeight);
    var raw = clamp(-rect.top / distance, 0, 1);
    var stack = smooth(clamp((raw - 0.05) / 0.72, 0, 1));
    var reveal = smooth(clamp((raw - 0.54) / 0.24, 0, 1));
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-pfs-card]'));
    var phone = window.innerWidth <= 720;
    var cardWidth = cards.length ? cards[0].offsetWidth : 0;
    var startStep = cardWidth + (phone ? 16 : 36);
    var endStep = phone ? 9 : 40;

    cards.forEach(function (card, index) {
      var x = index * (startStep + ((endStep - startStep) * stack));
      var scale = 1 - (index * 0.02 * stack);
      var brightness = 1 - (index * 0.12 * stack);

      card.style.transform = 'translate3d(' + x.toFixed(2) + 'px, -50%, 0) scale(' + scale.toFixed(4) + ')';
      card.style.filter = 'brightness(' + brightness.toFixed(4) + ')';
      card.style.zIndex = String(cards.length - index);
    });

    section.style.setProperty('--pfs-reveal', reveal.toFixed(4));
    section.setAttribute('data-copy-visible', String(reveal > 0.02));
  }

  function updateAll() {
    raf = 0;
    sections.forEach(updateSection);
  }

  function requestUpdate() {
    if (raf) return;
    raf = window.requestAnimationFrame(updateAll);
  }

  sections.forEach(function (section) {
    section.setAttribute('data-pfs-ready', 'true');
  });

  document.addEventListener('scroll', requestUpdate, { passive: true, capture: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  window.addEventListener('load', requestUpdate, { once: true });
  requestUpdate();
})();
